// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"e71586f1","587":"4cf9f00a","615":"78ec6b31"}[chunkId] + ".chunk.css";
};